<template>
    <div>
        <b-navbar fixed="top" toggleable="lg" type="dark" variant="primary">
            <b-navbar-brand to="/inicio">
                <img alt="logo" src="../assets/logo-menu.png" width="110px">
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav>
                    
                </b-navbar-nav>

                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">
                    <b-nav-item to="/inicio">INICIO</b-nav-item>

                    <b-nav-item-dropdown text="PERSONAL" right>
                        <b-dropdown-item to="/perfil">PERFIL</b-dropdown-item>
                    </b-nav-item-dropdown>

                    <b-nav-item-dropdown text="INFORMACIÓN GENERAL" right>
                        <b-dropdown-item to="/noticias">NOTICIAS</b-dropdown-item>
                        <b-dropdown-item to="/galeria">GALERÍA</b-dropdown-item>
                        <b-dropdown-item to="/sitiosInteres">SITIOS DE INTERES</b-dropdown-item>
                    </b-nav-item-dropdown>

                    <b-nav-item-dropdown text="REGLAMENTOS" right>
                        <b-dropdown-item to="/regconstruc">REGLAMENTO DE CONSTRUCCIÓN</b-dropdown-item>
                        <b-dropdown-item to="/reginstalaciones">REGLAMENTO DE USO DE INSTALACIONES</b-dropdown-item>
                        <b-dropdown-item to="/regimencondom">REGIMEN DE CONDOMINIO</b-dropdown-item>
                    </b-nav-item-dropdown>

                    <b-nav-item-dropdown text="FINANZAS" right>
                        <b-dropdown-item to="/consultasaldo">CONSULTA DE SALDO</b-dropdown-item>
                        <!-- <b-dropdown-item to="/consumoagua">Historial de consumos de agua</b-dropdown-item> -->
                        <b-dropdown-item to="/consultapagos">CONSULTA DE PAGOS</b-dropdown-item>
                        <div class="dropdown-divider"></div>
                        <b-dropdown-item to="/inffinan">INFORMACIÓN FINANCIERA</b-dropdown-item>
                        <b-dropdown-item to="/reportes">REPORTES</b-dropdown-item>
                        <b-dropdown-item to="/minutas">MINUTAS, ASAMBLEAS Y JUNTAS</b-dropdown-item>
                    </b-nav-item-dropdown>

                    <b-nav-item-dropdown toggle-class="item-menu" text="CONTACTO" right>
                        <b-dropdown-item to="/contacto">CONTACTANOS</b-dropdown-item>
                        <div class="dropdown-divider"></div>
                        <b-dropdown-item to="/directorio">DIRECTORIO DE PERSONAL</b-dropdown-item>
                        <b-dropdown-item to="/mesa">MESA DIRECTIVA</b-dropdown-item>
                        <div class="dropdown-divider"></div>
                        <b-dropdown-item to="/aviso">AVISO DE PRIVACIDAD</b-dropdown-item>
                    </b-nav-item-dropdown>

                    <b-nav-item v-show="token == ''" @click="goadmin">| ADMINISTRACIÓN |</b-nav-item>
                    <b-nav-item v-show="token != ''" @click="salir">| SALIR <b-icon-box-arrow-right></b-icon-box-arrow-right> </b-nav-item>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
        </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'Menu',
    props: {
        token: {
            type: String,
            default: ''
        }
    },
    methods: {
        goadmin() {
            window.location = `${this.url}`
        },
        salir() {
            this.$emit('salir')
        }
    },
    computed: {
        url() {
            if ( ["localhost", "127.0.0.1", ""].includes(window.location.hostname) ) {
                return this.urlSandbox
            } else {
                return this.urlProd
            }
        },
        ...mapState(['urlProd']),
        ...mapState(['urlSandbox'])
    }
}
</script>